import React from 'react'

import EstimationManagement from './abstract/EstimationManagement'
import Loading from '../../../common/component/Loading'

class Dashboard extends EstimationManagement {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }
  componentWillMount () {
    this.loadRecentEstimationAndTemplateList()
  }
  sorter (a, b) {
    if (a.lastUpdateDateTime < b.lastUpdateDateTime) return 1
    if (a.lastUpdateDateTime > b.lastUpdateDateTime) return -1
    return 0
  }
  loadRecentEstimationAndTemplateList () {
    const onSuccessToEstimation = (res) => {
      const recentEstimationList = res.body.data.sort(this.sorter).slice(0, 5)
      this.setState({
        isRecentEstimationListLoaded: true,
        recentEstimationList: recentEstimationList.map(item => ({ id: item.estimationId, data: item }))
      })
    }
    this.loadEstimationListByEstimationType('real', onSuccessToEstimation)
    const onSuccessToTemplate = (res) => {
      const recentTemplateList = res.body.data.sort(this.sorter).slice(0, 5)
      this.setState({
        isRecentTemplateListLoaded: true,
        recentTemplateList: recentTemplateList.map(item => ({ id: item.estimationId, data: item }))
      })
    }
    this.loadEstimationListByEstimationType('template', onSuccessToTemplate)
  }
  onDashButtonClicked (name) {
    switch (name) {
      case 'dashboard':
        this.props.history.push('/company_user')
        break
      case 'informationList':
        this.props.history.push('/company_user/information')
        break
      case 'sharedFileList':
        this.props.history.push('/company_user/shared_files')
        break
      case 'estimation':
        this.props.history.push('/company_user/estimation/real')
        break
      case 'estimationTemplate':
        this.props.history.push('/company_user/estimation/template')
        break
      case 'personalSettingHome':
        this.props.history.push('/company_user/personal_setting_home')
        break
      case 'surveyAnswer':
        this.props.history.push('/company_user/survey_answer')
        break
      default:
        break
    }
  }
  goEstimation (estimationType, estimationId, e) {
    this.props.history.push('/company_user/estimation/' + estimationType + '/detail/' + estimationId)
  }
  onHelpLinkClicked (helpId) {
    const link = document.createElement('a')
    link.target = '_blank'
    link.href = '/company_user/help/' + helpId
    link.rel = 'noopener noreferrer'
    link.click()
  }
  onPdfLinkClicked (filePath, e) {
    e.preventDefault()
    var targetFile = 'https://katawaku2.s3.ap-northeast-1.amazonaws.com/files/' + filePath
    window.open(targetFile, '_blank', 'noopener,noreferrer')
  }
  render () {
    if (!this.state.isRecentEstimationListLoaded || !this.state.isRecentTemplateListLoaded) {
      return <Loading />
    }
    const recentListStyle = {
      cursor: 'pointer',
      color: '#128dc2'
    }
    const recentEstimationList = this.state.recentEstimationList.map((estimation) => {
      return (
        <li key={estimation.data.estimationId} onClick={(e) => this.goEstimation('real', estimation.data.estimationId, e)} style={recentListStyle}>
          {estimation.data.estimationTitle}
        </li>
      )
    })
    const recentTemplateList = this.state.recentTemplateList.map((template) => {
      return (
        <li key={template.data.estimationId} onClick={(e) => this.goEstimation('template', template.data.estimationId, e)} style={recentListStyle}>
          {template.data.estimationTitle}
        </li>
      )
    })
    return (
      <div>
        <section className='nav nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>企業ユーザーマイページ<br />
                    <small>こちらから全ての作業を開始できます。</small>
                  </h3>
                </header>
              </div>
              <div className='page-nav-options'>
                <div className='span9'>
                  <ul className='nav nav-tabs'>
                    <li className='active'><a onClick={(e) => this.onDashButtonClicked('dashboard')} ><i className='icon-home' />Home</a></li>
                    <li><a className='kw-btn-success' onClick={(e) => this.onDashButtonClicked('informationList')}><i className='icon-info-sign' />お知らせ</a></li>
                    <li><a className='kw-btn-warning' onClick={(e) => this.onDashButtonClicked('sharedFileList')} ><i className='icon-file' />共有ファイル</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='row'>
            <div className='span8'>
              <div className='blockoff-left'>
                <legend className='lead'>
                  ご利用方法
                </legend>
                <p>
                  利用シーンに合わせて、以下のガイドをご用意しております。
                </p>
                <h6>[初級者編]</h6>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help001', e)}>初めて見積書を作成し保存する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help002', e)}>保存した見積書を印刷する</a></li>
                </ul>
                <h6>[中級者編]</h6>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help003', e)}>保存した見積書をコピーして雛型を作成し保存する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help004', e)}>保存した雛型から新しい見積書を作成する</a></li>
                </ul>
                <h6>[上級者編]</h6>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help005', e)}>保存した見積書をコピーして新しい見積書を作成し保存する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help006', e)}>保存した雛型から新しい雛型を作成する</a></li>
                </ul>
                <h6>[番外編]</h6>
                <ul>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help007', e)}>パスワードを変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help008', e)}>メールアドレスを変更する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help009', e)}>メール通知を受信しないように設定する</a></li>
                  <li><a onClick={(e) => this.onHelpLinkClicked('help010', e)}>サポート対象のホームページ閲覧ソフトChromeをダウンロードする</a></li>
                </ul>
                <h6>[共通編]ユーザーのためのシステム利用マニュアル</h6>
                <ul>
                  <li><a onClick={(e) => this.onPdfLinkClicked('1-system_registration_manual.pdf', e)}>システム利用登録マニュアル</a></li>
                  <li><a onClick={(e) => this.onPdfLinkClicked('2-bookmark_manual.pdf', e)}>ブックマーク登録・システムアクセスマニュアル</a></li>
                  <li><a onClick={(e) => this.onPdfLinkClicked('3-system_detailed_manual.pdf', e)}>システム詳細マニュアル</a></li>
                  <li><a onClick={(e) => this.onPdfLinkClicked('4-system_manual_revised.pdf', e)}>システムマニュアル改訂版</a></li>
                  <li><a href="/files/keihi_sheet_guide.pptx" download>型枠工事安全衛生経費算定シート作成手順</a></li>
                  <li><a href="/files/keihi_sheet.xlsx" download>型枠工事安全衛生経費算定シート</a></li>
                </ul>
              </div>
            </div>
            <div className='span8'>
              <div className='box'>
                <div className='box-header'>
                  <i className='icon-bookmark' />
                  <h5>ショートカット</h5>
                </div>
                <div className='box-content'>
                  <h6>各機能へのショートカット</h6>
                  <div className='btn-group-box'>
                    <a onClick={(e) => this.onDashButtonClicked('informationList')}><button className='btn kw-btn-success' ><i className='icon-info-sign icon-large' /><br /><span>お知らせ</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('sharedFileList')}><button className='btn kw-btn-warning' ><i className='icon-file icon-large' /><br /><span>共有ﾌｧｲﾙ</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('estimation')}><button className='btn kw-btn-info' ><i className='icon-list-alt icon-large' /><br /><span>見積書</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('estimationTemplate')}><button className='btn kw-btn-inverse' ><i className='icon-hdd icon-large' /><br /><span>雛型</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('personalSettingHome')}><button className='btn' ><i className='icon-user icon-large' /><br /><span>個人設定</span></button></a>
                    <a onClick={(e) => this.onDashButtonClicked('surveyAnswer')}><button className='btn kw-btn-default'><i className='icon-file icon-large' /><br /><span>ｱﾝｹｰﾄ回答</span></button></a>
                  </div>
                  <h6>最近更新した見積書一覧</h6>
                  <ul>
                    {recentEstimationList}
                  </ul>
                  <h6>最近更新した見積書雛型一覧</h6>
                  <ul>
                    {recentTemplateList}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/Dashboard.js